import { useComponentState } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties, ReactNode, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import ModalLogin from "src/components/ModalLogin";
import ModalRegister from "src/components/ModalRegister";
import ModalResetPassword from "src/components/ModalResetPassword";
import Translate from "src/components/Translate";
import constants from "src/constants";
import translate from "src/functions/translate";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sHeroBanner } from "src/styles/sHeroBanner.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  children?: ReactNode;
  setAlertResetPassword?: (setAlertResetPassword: boolean) => void;
};

const HeroBanner = ({
  style,
  className,
  children,
  setAlertResetPassword,
}: Props) => {
  const { locale: lang } = useRouter();
  const [activeElement, setActiveElement] = useState(1);
  var openModalLogin = useComponentState(false);
  var openModalRegister = useComponentState(false);
  var openModalResetPassword = useComponentState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (activeElement === 3) {
        setActiveElement(1);
      } else {
        setActiveElement(activeElement + 1);
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [activeElement]);

  const animatedText = (
    label: string,
    firstItem: string,
    secondItem: string,
    thirdItem: string,
    position: string
  ) => {
    let width = 0;
    if (activeElement === 1) {
      width = firstItem.length * 16;
    }
    if (activeElement === 2) {
      width = secondItem.length * 16;
    }
    if (activeElement === 3) {
      width = thirdItem.length * 16;
    }

    return (
      <div className="animated-wrapper">
        <span className="animated-label">{label}</span>
        <span className={"animated-text " + position}>
          <span className={activeElement === 1 ? "is-active" : "is-inactive"}>
            {firstItem}
          </span>
          <span className={activeElement === 2 ? "is-active" : "is-inactive"}>
            {secondItem}
          </span>
          <span className={activeElement === 3 ? "is-active" : "is-inactive"}>
            {thirdItem}
          </span>
        </span>
      </div>
    );
  };

  return (
    <div className={composeClassNames([sHeroBanner, className])}>
      <Heading
        type={`h1`}
        className={composeClassNames([sGroupTitle, "asana-list-title"])}
        title={translate(`Satisfaction and health begin with soul care`, lang)}
      />
      <div className="heroText">
        {animatedText(
          translate(`My fitness level is`, lang),
          translate(`beginner`, lang) + ",",
          translate(`intermediate`, lang) + ",",
          translate(`advanced`, lang) + ",",
          "delay-1"
        )}
        {animatedText(
          translate(`I want to`, lang),
          translate(`calm down`, lang),
          translate(`strengthen the core`, lang),
          translate(`improve focus`, lang),
          "delay-2"
        )}
        {animatedText(
          translate(`and I am into`, lang),
          translate(`relaxation`, lang) + ".",
          translate(`asana exercise`, lang) + ".",
          translate(`meditation`, lang) + ".",
          "delay-3"
        )}
      </div>
      <div className={composeClassNames([sButtons, "buttons"])}>
        <Button
          variant={`primary`}
          className={composeClassNames([sButton, className])}
          onClick={function () {
            return openModalRegister.change(true);
          }}
          style={style}
          size={`lg`}
        >
          <Translate tKey={`Start your free trial`} />
        </Button>
        {constants.Show.homepageHeroGiftCard && (
          <Button
            variant={`outline-primary`}
            className={composeClassNames([sButton, className])}
            style={style}
            size={`lg`}
          >
            <Translate tKey={`Send a gift card`} />
          </Button>
        )}
      </div>
      <ModalLogin
        openModalLogin={openModalLogin}
        openModalRegister={openModalRegister}
        openModalResetPassword={openModalResetPassword}
        key={`ModalLogin`}
      />
      <ModalRegister
        openModalLogin={openModalLogin}
        openModalRegister={openModalRegister}
        key={`ModalRegister`}
      />
      <ModalResetPassword
        openModalResetPassword={openModalResetPassword}
        key={`ModalResetPassword`}
        setAlertResetPassword={setAlertResetPassword}
      />
    </div>
  );
};

export default HeroBanner;
